export default __webpack_public_path__ + "static/media/Metamask.7cec90c4.svg";